module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1800.33e939b9.svg";